import { createContext, useContext } from 'react';

import type { TableSectionContextProps } from './table.types';

const TableSectionContext = createContext<null | TableSectionContextProps>(null);

export function useTableSectionContext(): null | TableSectionContextProps {
  return useContext(TableSectionContext);
}

export default TableSectionContext;
